import React, { Component } from 'react'
import Login from '../tabs/authorization/component/Login'
import { connect } from 'react-redux'
import 'react-notifications/lib/notifications.css'
import { withStyles } from '@material-ui/core'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/slide.css'
import Menu from './Menu/Menu'
import { BrowserRouter, Redirect, Route, Switch, withRouter } from 'react-router-dom'
import Bots from '../tabs/home/Home'
import QcsHome from '../tabs/home/QcsHome'
import PackageBuilder from '../tabs/home/PackageBuilder'
import { HOME_PATH, AUTH0_CAREPLAN_AUTHORIZE_URL, AUTH0_CAREPLAN_REDIRECT_FLAG } from '../configs'
import NotificationSnackbar from '../uiKit/Notification/Notification'
import Unavailable from './Unavailable/Unavailable'
import EmailConfirmation from '../tabs/authorization/component/EmailConfirmation'
import AfterSignUp from '../tabs/authorization/component/AfterSignUp'
import { NOTIFICATION_DEFAULT } from '../constants/notificationsPermissions'
import NotificationService from '../services/notificationService'
import { StyledToastContainer } from '../uiKit/StyledToastContainer'
import { AccountContainer } from '../tabs/account/AccountContainer'
import WidgetDemo from '../tabs/widgetDemo/WidgetDemo'
import AiChatDemo from '../tabs/aiChatDemo/AiChatDemo'
import OtpPage from '../tabs/authorization/component/OtpPage'
import Auth0SessionResume from '../tabs/authorization/component/Auth0SessionResume'
import QcsHandoffErrorPage from '../tabs/authorization/component/QcsHandoffErrorPage'
import { QCS_HANDOFF_ERROR_PATH, QCS_ACCESS_DENIED_PATH } from '../tabs/authorization/helpers/qcsHandoffError'
import { getQcsHandoffId } from '../tabs/authorization/helpers/getQcsHandoffId'
import { hasPermissionForFeatureInAnyBot, hasAdminAccessOnAnyBot } from '../security'

const styles = () => ({
  app: {
    width: '100%',
  },
})

const PackageBuilderGate = connect(state => ({ adminUser: state.adminUser }))(props => {
  if (!props.adminUser) return null
  if (!hasAdminAccessOnAnyBot(props.adminUser.botAccesses)) {
    return <Redirect to={`${HOME_PATH}/qcs`} />
  }
  return <PackageBuilder {...props} />
})

class App extends Component {
  askForNotification() {
    if (typeof Notification !== 'undefined' && Notification.permission === NOTIFICATION_DEFAULT) {
      NotificationService.askPermission()
    }
  }

  render() {
    this.askForNotification()
    const { classes, security } = this.props
    const ACCOUNT_SETTINGS = 'account-settings'

    return (
      <div className={classes.app}>
        <BrowserRouter>
          <Switch>
            <PrivateRoute
              isAuthenticated={security.authenticated}
              exact
              path={HOME_PATH + '/qcs'}
              component={QcsHome}
            />
            <PrivateRoute
              isAuthenticated={security.authenticated}
              exact
              path={HOME_PATH + '/packages'}
              component={PackageBuilderGate}
            />
            <PrivateRoute isAuthenticated={security.authenticated} exact path={HOME_PATH + '/'} component={Bots} />
            <Route path={'/login'} component={Login} />
            <Route exact path={'/sign-up'} component={Login} />
            <Route exact path={'/forgot-password'} component={Login} />
            <Route exact path={'/reset-password'} component={Login} />
            <Route exact path={'/sign-up/confirm'} component={AfterSignUp} />
            <Route exact path={'/otp'} component={Login}/>
            <Route path={'/sign-up/:code'} component={Login} />
            <Route path={'/unavailable'} component={Unavailable} />
            <Route path={'/link-expired'} component={() => <Unavailable linkExpired={true} />} />
            <Route exact path={QCS_HANDOFF_ERROR_PATH} component={QcsHandoffErrorPage} />
            <Route exact path={QCS_ACCESS_DENIED_PATH} component={QcsHandoffErrorPage} />
            <Route path={'/mail-confirm'} component={EmailConfirmation} />
            <Route path={'/widget-demo/:botId'} component={WidgetDemo} />
            <Route path={'/ai-chat-demo/:botId'} component={AiChatDemo} />

            { hasPermissionForFeatureInAnyBot(ACCOUNT_SETTINGS) &&
              <PrivateRoute
                isAuthenticated={security.authenticated}
                exact
                path={'/account-settings'}
                component={AccountContainer}
              />
            }
            <PrivateRoute isAuthenticated={security.authenticated} path={HOME_PATH + '/bot/:botId/'} component={Menu} />
            <Redirect from="/" to="/admin" />
          </Switch>
        </BrowserRouter>
        <NotificationSnackbar />
        <StyledToastContainer />
      </div>
    )
  }
}

const PrivateRoute = ({ component: Component, isAuthenticated, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthenticated) {
        return <Component {...props} />
      }

      // A handoff link signs in with its id on /login; Auth0 authorize would drop the id.
      if (getQcsHandoffId(props.location)) {
        return (
          <Redirect
            to={{ pathname: '/login', search: props.location.search, state: { from: props.location } }}
          />
        )
      }

      // Domain / protected entry when logged out → Auth0 careplan authorize.
      // If we already tried this session, fall back to classic /login (handoff,
      // email/password, Auth0 failure) to avoid a redirect loop.
      let alreadyTriedAuth0 = false
      try {
        alreadyTriedAuth0 = sessionStorage.getItem(AUTH0_CAREPLAN_REDIRECT_FLAG) === '1'
      } catch {
        alreadyTriedAuth0 = false
      }

      if (alreadyTriedAuth0) {
        return <Auth0SessionResume location={props.location} />
      }

      try {
        sessionStorage.setItem(AUTH0_CAREPLAN_REDIRECT_FLAG, '1')
      } catch {
        // ignore — still navigate to Auth0
      }
      window.location.replace(AUTH0_CAREPLAN_AUTHORIZE_URL)
      return null
    }}
  />
)

const mapStateToProps = state => ({
  security: state.security,
  adminUser: state.adminUser,
  activeBot: state.activeBot,
})

export default withRouter(withStyles(styles)(connect(mapStateToProps)(App)))
